export interface TrayDetails {
  type: 'reco' | 'similar';
  title: string;
  assestDetails?: {
    originalTitle?: string;
    contentId?: string;
    assetSubtype?: string;
    title?: string;
  };
  isRecommendedColumn: boolean;
  talamoosModelName: string;
  index: number;
  isEpisodeConsumption: boolean;
  pendingDataAvailable: boolean;
  isPendingResolved: boolean;
  allCollectionsResolved: boolean;
  tabName: string;
  pageName?: string;
  carouselTitle: string;
}

export enum MixpanelRailTitle {
  RECO = 'Recommended Rail Impression',
  OTHER = 'Page Rail Impression',
  SEARCH_LANDING = 'Search Rail Impression'
}
export enum MixpanelRailTypes {
  RECO = 'reco',
  SIMILAR = 'similar'
}

export interface TrayData {
  content: { title: string; value: string }[];
  partnerDetails: {
    content_partner_name: string;
    content_partner_id: number;
  };
}

export interface RailsMixpanelPayload {
  trayDetails: TrayDetails;
  trayData: TrayData;
  railIDs?: string;
  railElements?: string;
  activeSubscriptions: any;
}
